import { render, staticRenderFns } from "./TermosLgpd.vue?vue&type=template&id=5679c6b8"
import script from "./TermosLgpd.vue?vue&type=script&lang=js"
export * from "./TermosLgpd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports